import api from './api';

export interface Resource {
  id: string;
  stream_id: string;
  name: string;
  url?: string;
  description?: string;
  created_at: string;
}

export interface ResourceCreate {
  stream_id: string;
  name: string;
  url?: string;
  description?: string;
}

class ResourcesService {
  async getAll(streamId?: string): Promise<Resource[]> {
    const params = streamId ? { stream_id: streamId } : {};
    const response = await api.get('/resources/', { params });
    return response.data;
  }

  async getById(id: string): Promise<Resource> {
    const response = await api.get(`/resources/${id}`);
    return response.data;
  }

  async create(resource: ResourceCreate): Promise<Resource> {
    const response = await api.post('/resources/', resource);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/resources/${id}`);
  }
}

export const resourcesService = new ResourcesService();

